/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_ViewInputs */

const en_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const de_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const fr_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const es_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const it_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza`)
};

const nl_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijken`)
};

const pl_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyświetl`)
};

const fi_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä`)
};

const da_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis`)
};

const sv_jobs_view = /** @type {(inputs: Jobs_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Jobs_ViewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_view = /** @type {((inputs?: Jobs_ViewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_ViewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_view(inputs)
	if (locale === "fr") return fr_jobs_view(inputs)
	if (locale === "es") return es_jobs_view(inputs)
	if (locale === "it") return it_jobs_view(inputs)
	if (locale === "nl") return nl_jobs_view(inputs)
	if (locale === "pl") return pl_jobs_view(inputs)
	if (locale === "fi") return fi_jobs_view(inputs)
	if (locale === "da") return da_jobs_view(inputs)
	if (locale === "sv") return sv_jobs_view(inputs)
	return en_jobs_view(inputs)
});